import React, { useEffect } from "react";
import { clone } from "lodash";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import CustomRadio from "../../../components/CustomRadio/CustomRadio";

const sameJson = (a, b) => JSON.stringify(a || []) === JSON.stringify(b || []);

const SameAssociatesToggle = (props) => {
    const { data, setData, renderElement } = props;
    const isOn = data.same_illi_associates === 'Yes';

    useEffect(() => {
        if (!isOn) return;
        const lessor = data.illi_represented_lessor_agents;
        const lessee = data.illi_represented_lessee_agents;
        if (!sameJson(lessor, lessee)) {
            const newData = clone(data);
            newData.illi_represented_lessee_agents = clone(lessor || []);
            setData(newData);
        }
    }, [data.illi_represented_lessor_agents, data.same_illi_associates]);

    const handleToggle = (val) => {
        const newData = clone(data);
        newData.same_illi_associates = val;
        if (val === 'Yes') {
            newData.illi_represented_lessor = 'Yes';
            newData.illi_represented_lessee = 'Yes';
            newData.commission_distribution_lessor = '100';
            newData.commission_distribution_lessee = '0';
            newData.illi_represented_lessee_agents = clone(newData.illi_represented_lessor_agents || []);
        }
        setData(newData);
    };

    return (
        <>
            <GridItem xs={12} sm={12} md={12}>
                <div className="group-wrap">
                    <CustomRadio
                        label="Is Lessor and Lessee represented by the same illi associates?,Yes,No"
                        options={['Yes', 'No']}
                        value={data.same_illi_associates || ''}
                        onChange={(e) => handleToggle(e.target.value)}
                    />
                </div>
            </GridItem>

            {isOn && (
                <GridItem xs={12} sm={12} md={12}>
                    <div className="group-wrap">
                        <h4 style={{ marginTop: 0 }}>illi Represented - Lessor and Lessee</h4>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <div>{renderElement("illi_represented_lessor_agents")}</div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </GridItem>
            )}

            {!isOn && (
                <>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="group-wrap">
                            <GridContainer>
                                <GridItem xs={12} sm={3} md={3}>
                                    {renderElement("illi_represented_lessor")}
                                </GridItem>
                                <GridItem xs={12} sm={9} md={9}>
                                    {data.illi_represented_lessor === "Yes" && (
                                        <div>{renderElement("illi_represented_lessor_agents")}</div>
                                    )}
                                </GridItem>
                            </GridContainer>
                        </div>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                        <div className="group-wrap">
                            <GridContainer>
                                <GridItem xs={12} sm={3} md={3}>
                                    {renderElement("illi_represented_lessee")}
                                </GridItem>
                                <GridItem xs={12} sm={9} md={9}>
                                    {data.illi_represented_lessee === "Yes" && (
                                        <div>{renderElement("illi_represented_lessee_agents")}</div>
                                    )}
                                </GridItem>
                            </GridContainer>
                        </div>
                    </GridItem>
                </>
            )}
        </>
    );
};

export default SameAssociatesToggle;
